const NORMALIZED_VIEWBOX_SIZE_PX = 24;
function normalizeStrokeWidth(strokeWidth, viewBoxSizePx) {
  return strokeWidth / NORMALIZED_VIEWBOX_SIZE_PX * viewBoxSizePx;
}

export { NORMALIZED_VIEWBOX_SIZE_PX, normalizeStrokeWidth };
//# sourceMappingURL=normalizeStrokeWidth.js.map
